// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_MESSAGE_VIOLATES_RULES = "Nahlas nevhodn\u00fd p\u0159\u00edsp\u011bvek";
export const DELETE = "Vyma\u017e";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_POST_EDIT_MENU = "Uprav";
export const FORUM_POST_EDIT_TITLE_MENU = "Uprav nadpis";
export const FORUM_THREAD_SEO_WITH_AI = "Uprav s AI pro lep\u0161\u00ed SEO";
export const PIN_POST = "P\u0159ipnout nahoru";
export const SEND_HEART_TO_username = "Po\u0161li srd\u00ed\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
export const UNPIN_POST = "Zru\u0161it p\u0159ipnut\u00ed";
